import { z } from 'zod';
export const UnifiedApiResponseSchema = <T extends z.ZodType>(dataSchema: T) =>
  z.object({
    success: z.boolean(),
    data: dataSchema.nullable(),
    message: z.string(),
    error: z
      .object({
        message: z.string(),
        code: z.string(),
        details: z.unknown().optional(),
      })
      .optional(),
    meta: z
      .object({
        timestamp: z.iso.datetime(),
        requestId: z.string().optional(),
      })
      .optional(),
  });
export const UnifiedSuccessResponseSchema = <T extends z.ZodType>(
  dataSchema: T
) =>
  z.object({
    success: z.literal(true),
    data: dataSchema,
    message: z.string(),
    meta: z
      .object({
        timestamp: z.iso.datetime(),
        requestId: z.string().optional(),
      })
      .optional(),
  });
export const UnifiedErrorResponseSchema = z.object({
  success: z.literal(false),
  data: z.null(),
  message: z.string(),
  error: z.object({
    message: z.string(),
    code: z.string(),
    details: z.unknown().optional(),
  }),
  meta: z
    .object({
      timestamp: z.iso.datetime(),
      requestId: z.string().optional(),
    })
    .optional(),
});
export type UnifiedApiResponse<T = unknown> = z.infer<
  ReturnType<typeof UnifiedApiResponseSchema<z.ZodType<T>>>
>;
export type UnifiedSuccessResponse<T = unknown> = z.infer<
  ReturnType<typeof UnifiedSuccessResponseSchema<z.ZodType<T>>>
>;
export type UnifiedErrorResponse = z.infer<typeof UnifiedErrorResponseSchema>;
